import { DispensaryCollectionPage } from 'src/dispensary/collection';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

export default Object.assign(DispensaryCollectionPage, { layout: MainDispensaryLayout });
